<app-phx-input-quantity-with-warehouse #input ngDefaultControl
        [ngModel]="quantity()"
        [ngModelOptions]="{standalone: true}"
        [showWarehouseStockButton]="props?.showWarehouseStockButton"
        [product]="product()" 
        [productId]="productId()" 
        [storagePlace]="storagePlace()" 
        [storagePlaceId]="storagePlaceId()" 
        [serial]="serial()" 
        [lotNumber]="lotNumber()" />